//@flow
import React from 'react';
import AccessibleButtonWrapper from './AccessibleButtonWrapper.react';

function getClassName(name:?string) {
  return 'close-icon-component ' + (name || '');
}

export default function IconClose(props:{ closeAction:() => void, className?:?string }) {
  return (
    <AccessibleButtonWrapper
      label="Close button"
      className={getClassName(props.className)}
      action={props.closeAction}
    />
  );
}
